import React,{useEffect} from 'react';
import './ClinicDetails.css';
import Layout from '../../components/Layout';
import img4 from '../../images/priya-chikani.png';
import QuotesSlider from '../Landingpage/QuotesSlider';

const ClinicDetails = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    },[]);

    return (
        <Layout>
            <div className="about-me-container">
                
                <div className="about-me-profile">
                    <div className='profile-image-div'>
                        <img src={img4} alt="Profile" className="profile-image" />
                    </div>

                    <div className='clinic-detail-div'>
                        <div className='physiotherapist-name'>
                            <div><h2>Priya Chikani</h2></div>
                            <div><h3 className='abreviation'>Founder & Physiotherapist</h3></div>
                        </div>
                        <br/>
                        <p className='clinic-description'>
                            Hi, I'm Priya Chikani, the founder of MantraFlex and a dedicated Physiotherapist specializing in pelvic floor therapy. 
                            As a licensed Physiotherapist in Canada, I'm passionate about providing holistic care and personalized treatments to 
                            help individuals live pain-free, confident, and vibrant lives.
                        </p>
                        <p className="clinic-description">
                            At MantraFlex, I focus on the power of movement and balance, whether you're recovering from an injury, managing a 
                            chronic condition, or aiming to optimize your well-being. I create customized treatment plans using evidence-based 
                            therapies to address your unique needs, ensuring that you not only recover but thrive physically, mentally, 
                            and emotionally.
                        </p>
                        <p className="clinic-description">
                            I'm committed to supporting you on your journey to healing, helping you unlock your body's full potential. 
                            Your well-being is my top priority, and I'm here to guide you every step of the way, so you can get back to doing 
                            what you love with confidence and vitality. Welcome to MantraFlex!
                        </p>
                    </div>
                </div>
            </div>
            <QuotesSlider />
        </Layout>
    );
};

export default ClinicDetails;